import { WatchQueryFetchPolicy, useQuery } from '@apollo/client'
import { useSelector } from 'react-redux'

import { HasVisualAssortmentAccessDocument } from '__generated__/atlas-types'

import { atlasClient } from 'graphql/client'
import { isLiteRetailer as isLiteRetailerSelector } from 'store/currentUser/selectors'

interface UseHasVAAccessOptions {
  fetchPolicy?: WatchQueryFetchPolicy
}

export const useHasVAAccess = ({
  fetchPolicy = 'cache-first',
}: UseHasVAAccessOptions = {}) => {
  const isLiteRetailer = useSelector(isLiteRetailerSelector)
  const { data, loading, error, refetch } = useQuery(
    HasVisualAssortmentAccessDocument,
    {
      client: atlasClient,
      fetchPolicy,
      skip: !isLiteRetailer,
    },
  )

  const hasUserAccess = Boolean(data?.hasVisualAssortmentAccess?.hasUserAccess)
  const isAccessInitialized = Boolean(
    data?.hasVisualAssortmentAccess?.isAccessInitialized,
  )

  return {
    // With no assortment yet there are no assigned users to check against, so
    // the acting user is allowed in: adding the first products creates the
    // assortment and assigns them as its first user.
    hasVAAccess: !isAccessInitialized || hasUserAccess,
    hasUserAccess,
    isAccessInitialized,
    loading,
    error,
    refetch,
  }
}
